import React, { useState, useEffect, useCallback } from 'react';
import Check from '@material-ui/icons/Check';
import { compose, mapProps } from 'recompose';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Button from 'components/common/Buttons/Button';

import './SaveAssessmentButton.scss';

export const SaveAssessmentButton = props => {
  const { t, lastUpdated, onAssessmentSaved, isOwner } = props;
  const [showCheck, setShowCheck] = useState(false);
  const [loading, setLoading] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  const onSave = useCallback(() => {
    if (loading) {
      return;
    }
    setLoading(true);
    const id = setTimeout(() => {
      setLoading(false);
      setShowCheck(true);
      onAssessmentSaved(new Date());
    }, 1000);
    setTimeoutId(id);
  }, [loading, onAssessmentSaved]);

  useEffect(() => {
    setShowCheck(false);
    const loadTimeout = setTimeout(() => setLoading(false), 1000);
    return function cleanup() {
      clearTimeout(timeoutId, loadTimeout);
    };
  }, [timeoutId, lastUpdated]);

  const text = loading ? null : t('common.save');

  return (
    <div className={`${isOwner ? 'save-assessment-button' : ''}`}>
      <Button loading={loading} buttonStyle="secondary" onClick={onSave}>
        {showCheck ? <Check /> : text}
      </Button>
    </div>
  );
};

SaveAssessmentButton.defaultProps = {
  lastUpdated: null
};

SaveAssessmentButton.propTypes = {
  t: PropTypes.func.isRequired,
  lastUpdated: PropTypes.string,
  onAssessmentSaved: PropTypes.func.isRequired
};

export const SaveAssessmentButtonHOC = compose(
  withTranslation(),
  mapProps(props => {
    const { assessment, isOwner } = props;
    return {
      t: props.t,
      isOwner,
      lastUpdated: assessment.lastUpdated,
      onAssessmentSaved: props.onAssessmentSaved
    };
  })
);

export default SaveAssessmentButtonHOC(SaveAssessmentButton);
